import React, { useState, useEffect } from "react";
import { slide as Menu } from "react-burger-menu";
import { Link } from "react-router-dom";
import { activeLinkDashboard, activeLinkProfile } from "../common/allLinks";

export default function CommonSideNavbar({
  dashboardLink,
  profileLink,
  activeLink,
}) {
  const [values, setValues] = useState({
    isMobileBurgerMenuOpen: false,
  });

  const [windowWidthVal, setWindowWidthVal] = useState(window.innerWidth);

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidthVal(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const handleOnStateChange = (stateVal) => {
    setValues({
      ...values,
      isMobileBurgerMenuOpen: stateVal.isOpen,
    });
  };

  const closeMobileBurgerMenu = () => {
    setValues({
      ...values,
      isMobileBurgerMenuOpen: false,
    });
  };

  return (
    <>
      {windowWidthVal <= 767 ? (
        <>
          <nav className="navbar-mobile">
            <Menu
              right
              isOpen={values.isMobileBurgerMenuOpen}
              onStateChange={(stateVal) => handleOnStateChange(stateVal)}
              burgerButtonClassName={"menu"}
              customBurgerIcon={
                <img
                  src="/img/desktop/icons/mobile-burger-menu.svg"
                  className="front"
                  alt="nav front"
                />
              }
              customCrossIcon={
                <img
                  src="/img/desktop/icons/cross.svg"
                  className="nav-close-img"
                  alt="nav back"
                />
              }
              overlayClassName={"myOverlay"}
            >
              <span
                className={
                  activeLink === activeLinkDashboard
                    ? "menu-item mobile-text-gradient-1"
                    : "menu-item"
                }
              >
                <Link to={dashboardLink}>
                  <span onClick={() => closeMobileBurgerMenu}>Dashboard</span>
                </Link>
              </span>
              <span
                className={
                  activeLink === activeLinkProfile
                    ? "menu-item mobile-text-gradient-1"
                    : "menu-item"
                }
              >
                <Link to={profileLink}>
                  <span onClick={() => closeMobileBurgerMenu}>Profile</span>
                </Link>
              </span>
            </Menu>
          </nav>
        </>
      ) : (
        <nav className="mt-platform-sidenavbar">
          <ul>
            <li
              className={
                activeLink === activeLinkDashboard
                  ? "mt-platform-sidenavbar__active-li"
                  : ""
              }
            >
              <Link to={dashboardLink}>
                {activeLink === activeLinkDashboard ? (
                  <img
                    src="/img/desktop/icons/white-dashboard-icon.svg"
                    alt="dashboard active"
                  />
                ) : (
                  <img
                    src="/img/desktop/icons/gray-dashboard-icon.svg"
                    alt="dashboard"
                  />
                )}
              </Link>
            </li>
            <li
              className={
                activeLink === activeLinkProfile
                  ? "mt-platform-sidenavbar__active-li"
                  : ""
              }
            >
              <Link to={profileLink}>
                {activeLink === activeLinkProfile ? (
                  <img
                    src="/img/desktop/icons/white-profile-icon.svg"
                    alt="profile active"
                  />
                ) : (
                  <img
                    src="/img/desktop/icons/gray-profile-icon.svg"
                    alt="profile"
                  />
                )}
              </Link>
            </li>
          </ul>
        </nav>
      )}
    </>
  );
}
